import electronicCommunicationForm from "form/modal/electronicCommunication";

import { FORM_EDIT_ELECTRONIC_COMMUNICATION } from "../constants";

export const ElectronicCommunicationForm = electronicCommunicationForm.createInPageContainer(FORM_EDIT_ELECTRONIC_COMMUNICATION);
